import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { userPetsQuery } from '../graphql-operations';
import { gqlTypes } from '../types';

export interface UltraEligiblePet {
  petId: string;
  name: string;
  moduleId: string;
}

export default function useUltraEligiblePets(): UltraEligiblePet[] {
  const { data } = useQuery<gqlTypes.userPets>(userPetsQuery);

  return useMemo<UltraEligiblePet[]>(() => {
    const households = data?.currentUser?.userHouseholds ?? [];
    return households.flatMap((h) =>
      h.household.pets
        .filter((p) => p.device?.moduleId && p.device.subscription)
        .map((p) => ({ petId: p.id, name: p.name, moduleId: p.device!.moduleId })),
    );
  }, [data]);
}
